export interface State {
    [tableKey: string]: TableState;
}

export interface TableState {
    sorting: TableSorting;
    paging: TablePaging;
    selection: TableSelection;
    filters: TableFilters;
    search: string;
}

export const initialTableState = (defaultColumn: string): TableState => ({
    filters: {},
    paging: {
        currentPage: 0,
        itemsPerPage: 15,
        numberOfItems: 0,
        numberOfPages: 0,
    },
    search: '',
    selection: [],
    sorting: { column: defaultColumn, order: 'asc' },
});

export const initialState: State = {
    applications: initialTableState('title'),
    groups: initialTableState('name'),
    servers: initialTableState('hostname'),
    users: initialTableState('email'),
    workspaces: initialTableState('name'),
};

export interface TableSorting {
    column: string;
    order: 'asc' | 'desc';
}

export type TableFilter = string[];
export interface TableFilters {
    [key: string]: TableFilter;
}

export interface TablePaging {
    numberOfItems: number;
    numberOfPages: number;
    itemsPerPage: number;
    currentPage: number;
}

export type TableSelection = string[];